import { getGetJwtLoginIdpQueryKey } from '@framework/api-client/api/auth/jwt-controller/jwt-controller.ts';
import { AuthSource } from '@framework/auth/AuthSource.ts';
import { useIdpAutoLogin } from '@framework/auth/strategies/idp/useIdpAutoLogin.tsx';
import { type IFrontLoginFormProps } from '@framework/theme/front/FrontLoginForm.tsx';
import { LoginCard } from '@framework/ui/components/card/LoginCard.tsx';
import { LoaderSpin } from '@framework/ui/components/loader/LoaderSpin.tsx';
import { Button, Space } from 'antd';

/**
 * Form di login all'applicativo per la parte di Amministrazione
 */
export function AdminLoginForm(props: IFrontLoginFormProps) {
  const { loading = false, resolvePublicUrl } = props;

  const loginResult = useIdpAutoLogin(AuthSource.Admin);

  return (
    <LoaderSpin spinning={loginResult.isLoading ?? loading} transparent>
      <LoginCard title="Login" subTitle={process.env.THEME_LOGIN_SUBTITLE}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Button
            size="large"
            type="primary"
            block
            href={resolvePublicUrl(getGetJwtLoginIdpQueryKey('iam')[0])}
          >
            Accedi con Utenza di Dominio
          </Button>
        </Space>
      </LoginCard>
    </LoaderSpin>
  );
}
